import { render, staticRenderFns } from "./VehicleAccessAdd.vue?vue&type=template&id=893a8982&scoped=true"
import script from "./VehicleAccessAdd.vue?vue&type=script&lang=js"
export * from "./VehicleAccessAdd.vue?vue&type=script&lang=js"
import style0 from "./VehicleAccessAdd.vue?vue&type=style&index=0&id=893a8982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a8982",
  null
  
)

export default component.exports